import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

const BUTTON_PREFIX = 'fv-button'

const applyPrefixes = types =>
  []
    .concat(types)
    .map(type => `${BUTTON_PREFIX}-${type}`)
    .join(' ')

const Button = ({
  className,
  children,
  component: Component,
  kind,
  kinds,
  ...props
}) => (
  <Component
    className={classNames(
      'fv-button',
      className,
      kind && applyPrefixes(kind),
      kinds && applyPrefixes(kinds)
    )}
    {...props}
  >
    {children}
  </Component>
)

Button.propTypes = {
  children: PropTypes.node
}

Button.defaultProps = {
  component: 'button',
  role: 'button',
  type: 'button'
}

export default Button



// WEBPACK FOOTER //
// ../src/components/fv-ui/Button.js